import { render, staticRenderFns } from "./ManageAlias.vue?vue&type=template&id=c37e4c44"
import script from "./ManageAlias.vue?vue&type=script&lang=js"
export * from "./ManageAlias.vue?vue&type=script&lang=js"
import style0 from "./ManageAlias.vue?vue&type=style&index=0&id=c37e4c44&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c37e4c44')) {
      api.createRecord('c37e4c44', component.options)
    } else {
      api.reload('c37e4c44', component.options)
    }
    module.hot.accept("./ManageAlias.vue?vue&type=template&id=c37e4c44", function () {
      api.rerender('c37e4c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/ManageAlias.vue"
export default component.exports